/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-event
 * OpenAPI spec version: 1.0.0
 */

/**
 * Abacus event name, snake-cased
 */
export type AbacusEventName =
  (typeof AbacusEventName)[keyof typeof AbacusEventName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AbacusEventName = {
  approve_sales_files: "approve_sales_files",
  accounting_period_close: "accounting_period_close",
  accounting_period_mechanicals: "accounting_period_mechanicals",
  accounting_run_calculate: "accounting_run_calculate",
  accounting_run_calculate_nr: "accounting_run_calculate_nr",
  accounting_run_commit: "accounting_run_commit",
  adjustment_file_upload: "adjustment_file_upload",
  adjustment_file_worksheet_import: "adjustment_file_worksheet_import",
  apply_pending_adjustments: "apply_pending_adjustments",
  apply_royalty_correction: "apply_royalty_correction",
  apply_royalty_reversal: "apply_royalty_reversal",
  backfill: "backfill",
  calculate_payments: "calculate_payments",
  close_balance: "close_balance",
  collaborators_auto_report_run: "collaborators_auto_report_run",
  commit_advance_payment: "commit_advance_payment",
  commit_batch_payment: "commit_batch_payment",
  commit_mechanicals: "commit_mechanicals",
  commit_reversal_to_subledger: "commit_reversal_to_subledger",
  commit_royalties: "commit_royalties",
  commit_to_subledger: "commit_to_subledger",
  commit_vat: "commit_vat",
  commit_vat_summary: "commit_vat_summary",
  commit_withholding_tax: "commit_withholding_tax",
  confirm_advance_approval: "confirm_advance_approval",
  confirm_advance_payment: "confirm_advance_payment",
  confirm_approval: "confirm_approval",
  confirm_funds: "confirm_funds",
  generate_export: "generate_export",
  ingest_vat_summary: "ingest_vat_summary",
  legacy_sync_contract: "legacy_sync_contract",
  payment_accepted: "payment_accepted",
  payment_approval: "payment_approval",
  payments_generate: "payments_generate",
  payment_returned: "payment_returned",
  release_reserves: "release_reserves",
  return_advance_payment: "return_advance_payment",
  return_batch_payment: "return_batch_payment",
  return_vat_summary: "return_vat_summary",
  return_withholding_tax: "return_withholding_tax",
  approve_sales: "approve_sales",
  get_eligible_sales: "get_eligible_sales",
  ingest_sales_distro: "ingest_sales_distro",
  ingest_sales_nr: "ingest_sales_nr",
  sap_sync_contract: "sap_sync_contract",
  schedule_reserves: "schedule_reserves",
  send_payments: "send_payments",
  stage_royalty_correction: "stage_royalty_correction",
  stage_royalty_reversal: "stage_royalty_reversal",
  statement_period_close: "statement_period_close",
  take_reserves: "take_reserves",
  tax_withholding: "tax_withholding",
  upload_approval: "upload_approval",
} as const;
